import { Resource } from 'json-api-hooks';
import React from 'react';

import FormField from './FormField';
import { FormFieldDefinition } from './ResourceForm';

interface FormFieldsProps {
  defaultValues?: Record<string, unknown>;
  fields: FormFieldDefinition[];
  prefix?: string;
  resource?: Resource;
  storageKey?: string;
}

const FormFields = ({ defaultValues, fields, prefix, resource, storageKey }: FormFieldsProps) => {
  return (
    <>
      {fields?.map((formField) => (
        <FormField
          defaultValue={defaultValues ? defaultValues[formField.attribute] : undefined}
          formField={formField}
          key={formField.attribute.toString()}
          prefix={prefix}
          resource={resource}
          storageKeyPrefix={storageKey}
        />
      ))}
    </>
  );
};

export default FormFields;
